import React from "react";
import ReactDOM from "react-dom";
import Providers from "./shared/utils/providers";
import { HashRouter } from "react-router-dom";
import Handlers from "./api/mock/handlers";
import { getEnvironment } from "./shared/utils/environment";
import { EEnvironment } from "./shared/enums/env.enums";
import { ConfigContext } from "./components/configContext/ConfigContext.component";
import OktaAuthLayerFromConfig from "./components/OktaAuthLayerFromConfig.component";
import ApiInitializerLayer from "./components/ApiInitializerLayer.component";
import "./theme/global-styles/index.scss";

const render = () => {
  const App = require("./App").default;

  ReactDOM.render(
    <React.StrictMode>
      <Providers>
        <HashRouter>
          <ConfigContext>
            <OktaAuthLayerFromConfig>
              <ApiInitializerLayer>
                <App />
              </ApiInitializerLayer>
            </OktaAuthLayerFromConfig>
          </ConfigContext>
        </HashRouter>
      </Providers>
    </React.StrictMode>,
    document.getElementById("root")
  );
};

if (process.env.REACT_APP_ENABLE_MOCK === "true") {
  if (process.env.REACT_APP_MOCK_ALL === "true") {
    Handlers.mockAll = true;
  }
  const { worker } = require("./api/mock/browser");
  worker.start();
}

if (getEnvironment() == EEnvironment.LOCALDEV) {
  if (module.hot) {
    module.hot.accept("./App", render);
  }
}

render();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
